module.exports = __webpack_public_path__ + "img/value-bundles.f2422029.jpg";